var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { injectIntl } from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import Input from "@irati/ui/src/FormItem/Input";
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Search.prototype.render = function () {
        var _a = this.props, onChange = _a.onChange, value = _a.value, formatMessage = _a.formatMessage;
        return (React.createElement(Flex, { alignItems: "center" },
            React.createElement(Icon, { icon: IconTypes.search, marginRight: true }),
            React.createElement(Input, { name: "search", placeholder: formatMessage({ id: "admin.search.textInput.placeholder.findPeople" }), onChange: onChange, value: value, hideBorder: true, flush: true })));
    };
    return Search;
}(PureComponent));
export default injectIntl(Search);
